<template>
<div style="background-color: lightgray">
  <van-form @submit="onSubmit" >
  <van-row gutter="0" style="background-color: white;">
    <van-col span="24">
      <div style="display: flex;flex-flow: row nowrap;justify-content: space-around;">
        <van-field
            type="password"
            v-model="moneyPassword"
            placeholder="请输入提现密码"
            :rules="[{ required: true, message: '请输入正确内容' }]">
        </van-field>
      </div>
      <div style="display: flex;flex-flow: row nowrap;justify-content: space-around;">
        <van-field
            type="password"
            v-model="confirmMoneyPassword"
            placeholder="请输入确认提现密码"
            :rules="[{ required: true, message: errMessage }]">
        </van-field>
      </div>
    </van-col>
  </van-row>
  <van-row gutter="0" >
    <van-col span="24">
      <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
        <van-button type="info" style="margin: 5%;width: 200px;" native-type="submit">提交</van-button>
      </div>
    </van-col>
  </van-row>
  </van-form>
</div>
</template>

<script>
import {changeUserCashPwd} from '../../api/system/sys_user';
import {Toast} from "mint-ui";
export default {
  name: "ResetCashPassword",
  data(){
    return {
      moneyPassword:"",
      confirmMoneyPassword:"",
      errMessage:"请输入确认提现密码"
    }
  },
  mounted() {
    this.$emit("titleChange", "设置提现密码");
  },
  methods:{
    onSubmit(values) {
      if (this.moneyPassword !== this.confirmMoneyPassword){
        Toast({message: "两次密码不一致", type: 'error'});
      }else{
        changeUserCashPwd(this.moneyPassword).then(res=>{
          if (res.success){
            this.$router.back();
          }
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
